export default {
  name: 'text',
  type: 'layout',
  active: false,
  data: {
    color: ''
  }
}
